import {
  selectImportErrors,
  clearError,
} from "../../redux/slices/masterDataSlice";
import {
  selectSalesImportError,
  resetSalesImportState,
} from "../../redux/slices/salesImportSlice";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../ui/Modal";
import { useLanguage } from "../../contexts/LanguageContext";
import DataTable from "../ui/DataTable";

const ErrorLogModal = ({ isOpen, onClose, isLoading = false }) => {
  const importErrors = useSelector(selectImportErrors);
  const salesImportError = useSelector(selectSalesImportError);
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const handleClose = () => {
    if (isLoading) return;
    dispatch(clearError());
    dispatch(resetSalesImportState());
    onClose();
  };

  const data =
    importErrors?.length > 0
      ? importErrors
      : salesImportError?.length > 0
      ? salesImportError
      : [];

  const columns = [
    { key: "row", header: t("errorLog.row", "Row") },
    { key: "column", header: t("errorLog.column", "Column") },
    { key: "code", header: t("errorLog.code", "Code") },
    { key: "message", header: t("errorLog.message", "Message") },
    { key: "value", header: t("errorLog.value", "Value") },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t("errorLog.title")}
      size="lg"
    >
      <div className="p-6">
        <DataTable
          data={data}
          columns={columns}
          pagination={true}
          itemsPerPage={10}
        />
      </div>
    </Modal>
  );
};

export default ErrorLogModal;
